// Third-party
import React from 'react';

// Components
import ComparisonBaseCell from '../ComparisonTable/ComparisonBaseCell';
import ComparisonCategory from '@/types/comparison-category';
import ComparisonField from '@/types/comparison-field';

interface Props {
  categories: ComparisonCategory[];
}

class BMOGIFComparisonTableLabels extends React.Component<Props> {
  generateCategoryLabel = (category: ComparisonCategory) => (
    <ComparisonBaseCell className="bmo-gif-category-header">
      <span className="label-container">
        <span className="label">{category.label}</span>
      </span>
    </ComparisonBaseCell>
  );

  generateCategoryField = (field: ComparisonField, i: number) => (
    <ComparisonBaseCell key={i} className={field.key}>
      <span className="label-container">{field.label}</span>
    </ComparisonBaseCell>
  );

  render() {
    const { categories } = this.props;

    return (
      <div className="bmo-gif-comparison-table-labels">
        {categories.map(category => (
          <div className={`bmo-gif-comparison-category ${category.key}`} key={category.key}>
            {this.generateCategoryLabel(category)}

            {category.fields.map((field, i) => this.generateCategoryField(field, i))}
          </div>
        ))}
      </div>
    );
  }
}

export default BMOGIFComparisonTableLabels;
